<div class="d-flex flex-column">
    <app-text class="h4-strong text-c300 mb-2">{{title}}</app-text>
    <div [ngClass]="isListView? 'row list-view' : ''">
        <app-plan-card *ngFor="let plan of planList;" [plan]="plan" (clickCard)="onClickCard($event)"></app-plan-card>
        <div *ngFor="let month of durationList;" class="month-box cursor" (click)="onClickMonth(month)" [ngClass]="selectedMonth==month? 'month-box-selected' : 'bg-s0 text-c300'">
          <app-text class="h4-strong">{{month}}</app-text>
        </div>
    </div>
</div>
